import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";


import OntikShop from "../../Images/Project/Ontik/Shop.JPG";
import OntikDetails from "../../Images/Project/Ontik/Detail.JPG";
import OntikCart from "../../Images/Project/Ontik/cart.JPG";
import OntikAdmin from "../../Images/Project/Ontik/admin.JPG";


import mansionHome from "../../Images/Project/mansion/mansion-home.JPG";
import mansionApartment from "../../Images/Project/mansion/mansion-apartments.JPG";
import mansionReview from "../../Images/Project/mansion/mansion-review.JPG";
import mansionDashboard from "../../Images/Project/mansion/mansion-dashboard.JPG";

import adventourHome from "../../Images/Project//adventour/adventour-home.JPG";
import adventourLogin from "../../Images/Project//adventour/adventour-login.JPG";
import adventourBooking from "../../Images/Project//adventour/adventour-booking.JPG";
import adventourNews from "../../Images/Project//adventour/adventour-news.JPG";

import shebaHome from "../../Images/Project/sheba/sheba-home.JPG";
import shebaService from "../../Images/Project/sheba/sheba-services.JPG";
import shebaDept from "../../Images/Project/sheba/sheba-serv.JPG";
import shebaForm from "../../Images/Project/sheba/sheba-form.JPG";

import hotHome from "../../Images/Project/hotonion/hotHome.JPG";
import hotBreakfast from "../../Images/Project/hotonion/hotBreakfast.JPG";
import hotDinner from "../../Images/Project/hotonion/hotDinner.JPG";
import hotlogin from "../../Images/Project//hotonion/hotLogin.JPG";

import learnHome from "../../Images/Project/learnfast/learnHome.JPG";
import learnfeature from "../../Images/Project/learnfast/featureCourse.JPG";
import learnservice from "../../Images/Project/learnfast/allCourse.JPG";
import learnlogin from "../../Images/Project/learnfast/learnSignup.JPG";

import temp from "../../Images/Project/temperature.JPG";

import emaHome from "../../Images/Project/emajohn/emaHome.JPG";
import emaLogin from "../../Images/Project/emajohn/emaLogin.JPG";
import emaOrder from "../../Images/Project/emajohn/emaOrder.JPG";
import emaForm from "../../Images/Project/emajohn/emaForm.JPG";

import doctorsPOrtal from "../../Images/Project/doctorsPortal/doctorHome.JPG";
import doctorAppointment from "../../Images/Project/doctorsPortal/appointment.JPG";
import doctorDashboard from "../../Images/Project/doctorsPortal/dashboard.JPG";
import doctorLogin from "../../Images/Project/doctorsPortal/doctorLogin.JPG";


import {
  slideInRight,
  bounceIn,
  slideInLeft,
  slideInUp,
  slideInDown,
} from "react-animations";
import Radium, { StyleRoot } from "radium";

function Projects() {
  const styles = {
    slideInLeft: {
      animation: "x 3s",
      animationName: Radium.keyframes(slideInLeft, "bounce"),
    },
    slideInUp: {
      animation: "x 3s",
      animationName: Radium.keyframes(slideInUp, "bounce"),
    },
    slideInRight: {
      animation: "x 3s",
      animationName: Radium.keyframes(slideInRight, "bounce"),
    },
    bounceIn: {
      animation: "x 3s",
      animationName: Radium.keyframes(bounceIn, "bounce"),
    },
    slideInDown: {
      animation: "x 3s",
      animationName: Radium.keyframes(slideInDown, "bounce"),
    },
  };
  return (
    <StyleRoot>
      <Container fluid className="project-section">
        <Particle />
        <Container>
          <h1 className="project-heading" style={styles.slideInDown}>
            My Recent <strong className="purple">Works </strong>
          </h1>
          <div style={styles.slideInUp}>
            <p style={{ color: "white" }}>
              Here are a few projects I've worked on recently.
            </p>
          </div>
          <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
            <Col md={4} className="project-card">

              <ProjectCard
                home={OntikShop}
                about={OntikDetails}
                manage={OntikCart}
                add={OntikAdmin}
                imgPath={OntikShop}
                isBlog={false}
                title="Ontik Shop"
                description="This is a Full-Stack E-Commerce website.User can Select any Item and buy it.	Users can Register via Email and can login by using that Email. Users buy Products and see his/her product in the cart.
              Customize Dashboard for User and Admin.
              Front-end technology: React js, Redux Toolkit, React Bootstartp, React Router(V6), Firebase Authentication.
              Back-end technology: Node js,Express js, MongoDB"
                link="https://teck-shop-01.web.app/"
                gitlink='https://github.com/nhnajmul17/Ontik-shop'
                path='/ontik'

              />
            </Col>
            <Col md={4} className="project-card">

              <ProjectCard
                home={mansionHome}
                about={mansionApartment}
                manage={mansionReview}
                add={mansionDashboard}
                imgPath={mansionHome}
                isBlog={false}
                title="Mansion Residence"
                description="This is a Full-Stack Apartmnet rental website.	Users can Register via Email and can login by using that Email. Users can Rent an apartment and see his/her booking in the dashboard.
              Customize Dashboard for User and Admin.
              Front-end technology: React js, Material UI, React Router, Firebase Authentication.
              Back-end technology: Node js,Express js, MongoDB"
                link="https://mansion-residence.web.app/"
                gitlink='https://github.com/nhnajmul17/Mansion-Client'
                path='/mansion'

              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                home={adventourHome}
                about={adventourNews}
                manage={adventourLogin}
                add={adventourBooking}
                imgPath={adventourHome}
                isBlog={false}
                title="Adventour"
                description="This is an Full-Stack Tour based website users can find the best packages and can book their trip. Fully Responsive Website with Firebase Authentication login (Email, Google) system.
              Users can place a booking and can manage those bookings. Technology: React, Bootstrap, React-Router, MongoDB, Express Js, Firebase Authentication."
                link="https://adventour-001.web.app/"
                gitlink='https://github.com/nhnajmul17/Adventour-Client'
                path='/adventour'

              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                home={shebaHome}
                about={shebaService}
                manage={shebaDept}
                add={shebaForm}
                imgPath={shebaHome}
                isBlog={false}
                title="Sheba Care"
                description="This is a Hospital related Website. User can Choice the Medical services that they wants. Users can Login via Google sign, Github and Creating free account with Email. Users can book for a different type of treatment. Technology Used: React, Bootstrap, React-Router, Private Route, Firebase Authentication.
              "
                link="https://sheba-care.web.app/"
                gitlink='https://github.com/nhnajmul17/Sheba-Care'
                path='/sheba'

              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                home={hotHome}
                about={hotBreakfast}
                manage={hotDinner}
                add={hotlogin}
                imgPath={hotHome}
                isBlog={false}
                title="Red Onion"
                description="This is a Food Delivery and restaurant Website. Users can Choice the Food For Breakfast,Lunch and Dinner. Users can Login via Google sign, GitHub.
              Users can order food and give a review for each food and restaurant. (Works going on)
              Admin dashboard and user dashboard. (Working On it)
              Dynamic React Router Used in this Website
              user friendly website
              Front-end technology: React js,React Router,Bootstrap,"
                link="https://hot-onion-01.web.app/"
                gitlink='https://github.com/nhnajmul17/hot-onion'
                path='/hotonion'

              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                home={learnHome}
                about={learnfeature}
                manage={learnservice}
                add={learnlogin}
                imgPath={learnHome}
                isBlog={false}
                title="Learn Fast"
                description="Learnfast is a self learning platform that offers various digital courses. Our mission is to prepare the next generation suitable enough to face modern challenges. Here our courses are designed with the help of experts and being continuously updated so that no one lags behind knowledge. Technology used: React js,React Router,Bootstrap,"
                link="https://learn-fast-01.web.app/"
                gitlink='https://github.com/nhnajmul17/learn-fast-react-education'
                path='/learnfast'

              />
            </Col>



            <Col md={4} className="project-card">
              <ProjectCard
                home={doctorsPOrtal}
                about={doctorAppointment}
                manage={doctorDashboard}
                add={doctorLogin}
                imgPath={doctorsPOrtal}
                isBlog={false}
                title="Doctor's Portal"
                description="This is an Full-Stack Doctors Portal Website.Patients can Login via (Google,Facebook)and can Create account. patients can book Appointment by Date.Doctor can manage Appointment and see the appointment by data.User can Complete her/his Payment via Online payment system(Strip). Admin can delete, add, manage services.
              Admin can Make Admin also"
                link="https://doctors-portal-001.web.app/"
                gitlink='https://github.com/nhnajmul17/doctors-portal-client'
                path='/doctors'

              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                home={temp}
                about={temp}
                manage={temp}
                add={temp}
                imgPath={temp}
                isBlog={false}
                title="Temperature Hot"
                description="Temperature Hot is a website from that users can findout the weather condition of a city. User can easily write the city name in the search-bar and find the real time weather data. The Website built using simple HTML and JavaScript code."
                link="https://naju-temperature.netlify.app/"
                gitlink='https://github.com/nhnajmul17/temperature-hot'
              // path='/learnfast'

              />
            </Col>

            <Col md={4} className="project-card">
              <ProjectCard
                home={emaHome}
                manage={emaOrder}
                about={emaLogin}
                add={emaForm}
                imgPath={emaHome}
                isBlog={false}
                title="Ema-John e-Commerce"
                description="This is an Full-Stack e-commerce website.User can login the website create account.
              User Can Use (Google,Email) for Sign-in.
              User can Select the product and review order,see her/his total cost
              Front-end technology: React js,React Bootstrap,React Router,firebase
              Back-end technology: Node js,Express JS,MongoDB,firebase authentication"
                link="https://ema-john-simple-0001.firebaseapp.com/"
                gitlink='https://github.com/nhnajmul17/ema-john-simple'
                path='/emajohn'
              />
            </Col>
          </Row>
        </Container>
      </Container>
    </StyleRoot>
  );
}

export default Projects;
